<template>
  <div class="rt-progress-bar">
    <div class="rt-progress__outer">
      <div :style="computedWidth" class="rt-progres__inner"></div>
    </div>
    <div class="rt-progress-text">{{ msg }}</div>
  </div>
</template>

<script>
const MaxPercentage = 100;
export default {
  name: 'RtProgress',
  props: {
    percentage: {
      type: Number,
      default: 0
    },
    text: {
      type: String,
      default() {
        return this.$tx('当前进度', 'xpc.progress.text');
      }
    }
  },
  computed: {
    msg() {
      let { text, percentage } = this;
      return `${text} ${Math.min(MaxPercentage, percentage)}%`;
    },
    computedWidth() {
      return {
        width: `${Math.min(MaxPercentage, this.percentage)}%`
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtProgress.vue?1f6d1e5e